export const GET_BANNER_CONFIG = 'GET_BANNER_CONFIG';
